import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography, CircularProgress, Box } from '@mui/material';
import { useRegisterParcelDevice, useFCMDeviceToken } from '../hooks';

export default function RegisterUserDevice() {
  const { token: deviceToken, error } = useFCMDeviceToken();
  const [status, setStatus] = useState(null);
  const registerDevice = useRegisterParcelDevice();
  const userId = useSelector((state) => state.userProfile?.data?.user?.userId);

  useEffect(() => {
    if (deviceToken && userId) {
      setStatus('loading');
      registerDevice(userId, deviceToken)
        .then((res) => {
          if (res && res.success) {
            setStatus('success');
          } else {
            setStatus('error');
          }
        })
        .catch(() => setStatus('error'));
    }
  }, [deviceToken, userId, registerDevice]);

  // Don't block the UI if FCM fails - just return null
  if (error) return null;

  if (!deviceToken)
    return (
      <Box p={2} display="flex" alignItems="center" gap={1}>
        <CircularProgress size={20} />
        <Typography>Getting device token...</Typography>
      </Box>
    );
  if (status === 'loading')
    return (
      <Box p={2} display="flex" alignItems="center" gap={1}>
        <CircularProgress size={20} />
        <Typography>Registering device...</Typography>
      </Box>
    );

  // Success/error states can be silent or minimal
  return null;
}
